var _classCallCheck = require("/Users/steven/Documents/code/others/fourth_year_project/constellations/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/steven/Documents/code/others/fourth_year_project/constellations/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/steven/Documents/code/others/fourth_year_project/constellations/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/steven/Documents/code/others/fourth_year_project/constellations/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/Users/steven/Documents/code/others/fourth_year_project/constellations/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var blockcypher = require('./blockcypher');

var transaction = require('../models');

var ServiceError =
/*#__PURE__*/
function (_Error) {
  "use strict";

  _inherits(ServiceError, _Error);

  /**
   * @constructor
   * @param {number} status
   * @param {string} message
   */
  function ServiceError(status, message) {
    var _this;

    _classCallCheck(this, ServiceError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ServiceError).call(this, message));
    _this.status = status;
    _this.name = 'ServiceError';
    return _this;
  }

  return ServiceError;
}(_wrapNativeSuper(Error));

var ServiceResponse =
/**
 * @constructor
 * @param {number} status
 * @param {*} data
 */
function ServiceResponse(status, data) {
  "use strict";

  _classCallCheck(this, ServiceResponse);

  this.status = status;
  this.data = data;
};

var InternalError =
/*#__PURE__*/
function (_Error2) {
  "use strict";

  _inherits(InternalError, _Error2);

  /**
   * @constructor
   * @param {string} message
   */
  function InternalError(message) {
    var _this2;

    _classCallCheck(this, InternalError);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(InternalError).call(this, message));
    _this2.message = message;
    return _this2;
  }

  return InternalError;
}(_wrapNativeSuper(Error));
/**
 * push a transaction
 * @param {string} tx raw transaction
 * @param {'testnet' | 'mainnet'} network
 */


function pushtx(tx, network) {
  return blockcypher.pushtx(tx, network).then(function (response) {
    return new ServiceResponse(response.status, response.data);
  }).catch(function (error) {
    throw new ServiceError(error.response.status, error.response.data.error);
  });
}
/**
 * pull all unspent transactions belonging to an address
 * @param {string} address a valid bitcoin address
 * @param {'testnet' | 'mainnet'} network
 */


function pullUnspentTransactions(address, network) {
  return blockcypher.pullUnspentTransactions(address, network).then(function (response) {
    if (!response) {
      throw new InternalError("An error has occured. ".concat(address, " has no spendable balance."));
    }

    var data = Array.isArray(response.data) ? response.data : [response.data];
    var txs = [];

    for (var index = 0; index < data.length; index += 1) {
      var tx = data[index];
      var outputDataArray = Array.isArray(tx.outputs) ? tx.outputs : [tx.outputs];
      var outputs = [];

      for (var subindex = 0; subindex < outputDataArray.length; subindex += 1) {
        var output = outputDataArray[subindex];

        if (output.script_type === 'pay-to-pubkey-hash' && output.addresses.length === 1 && output.addresses[0] === address) {
          outputs.push(new transaction.TransactionOutput(subindex, output.script, output.value, address));
        }
      }

      txs.push(new transaction.Transaction(tx.hash, outputs));
    }

    return new ServiceResponse(response.status, txs);
  }).catch(function (error) {
    if (error instanceof InternalError) {
      throw error;
    }

    throw new ServiceError(error.response.status, error.response.data.error);
  });
}

module.exports = {
  pushtx: pushtx,
  pullUnspentTransactions: pullUnspentTransactions
};